export default __webpack_public_path__ + "static/media/kyselyt-lightblue.5736b094.svg";